const routesForPPLToCreate = {
  invoice: '/app/invoices/invoice',
  application: '/app/applications/create'
};

export default routesForPPLToCreate;
